// src/routes/users/CreateUser.jsx
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../../api/AuthService';

import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

const CreateUser = () => {
  const [loading, setLoading] = useState(false);

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [userName, setUserName] = useState('')
  const [country, setCountry] = useState("")
  const [monthlyCases, setMonthlyCases] = useState('')
  const [mobileNumber, setMobileNumber] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [profile, setProfile] = useState(null)
  const [roles, setRoles] = useState([])
  const [permissions, setpermissions] = useState([])
  const [role, setRole] = useState('')
  const [clientLoginUri, setClientLoginUri] = useState('');
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  const navigate = useNavigate();

  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    const checkboxId = parseInt(id, 10); // Convert id to a number

    setSelectedCheckboxes((prevSelected) => {
      if (checked) {
        // Add the checkbox ID to the array if checked
        return [...prevSelected, checkboxId];
      } else {
        // Remove the checkbox ID from the array if unchecked
        return prevSelected.filter((prevId) => prevId !== checkboxId);
      }
    });
  };
  
  const handleProfile = (event) => {
    const file = event.target.files[0];
    setProfile(file);
  };
  
  const createUserFunction = async () => {

    try {
      const formData = new FormData();

      if (!firstName) {
        toast.error("please enter first name", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });

        return;
      }

      if (!lastName) {
        toast.error("please enter last name", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
        return;
      }

      if (!userName) {
        toast.error("please enter username", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,

        });

        return;
      }
      
      if (!email) {
        toast.error("please enter email", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,

        });

        return;
      }
      
      if (!password) {
        toast.error("please enter password", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });

        return;
      }

      if (!confirmPassword) {
        toast.error("please re-enter password", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });

        return;
      }

      if (!role) {
        toast.error("Please choose user role", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });

        return;
      }

      setLoading(true);

      formData.append('first_name', firstName);
      formData.append('last_name', lastName);
      formData.append('username', userName);
      formData.append('email', email);
      formData.append('password', password);
      formData.append('password_confirmation', confirmPassword);
      formData.append('role_id', role);
      
      if (monthlyCases) {
        formData.append('monthly_target_cases', monthlyCases);
      }
      
      if (country) {
        formData.append('country_name', country);
      }
      
      if (mobileNumber) {
        formData.append('mobile_number', mobileNumber);
      }
      
      if (profile) {
        formData.append('profile_pic', profile);
      }
      
      if (clientLoginUri) {
        formData.append('client_login_uri', clientLoginUri);
      }
      
      if (selectedCheckboxes) {
        selectedCheckboxes?.map((id, index) => {
          formData.append(`permissions[${index}]`, id);
        })
      }

      const response = await AuthService.addUser(formData);
      
      if (response?.data?.status === 200)
      {
        toast.success(response?.data?.message, {
          autoClose: 1000,
          draggable: true,
          pauseOnHover: true,
        });
        
        setTimeout(() => {
          navigate('/users')
        }, 1300);

      } else {
        if (response?.data?.success === "Unauthenticated.") {
          navigate('/login');
        }

        toast.error(response?.data?.message, {
          autoClose: 2000,
          draggable: true,
          pauseOnHover: true,
        });
      }

    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
    }
    finally {
      setLoading(false)
    }
  };

  //get all roles
  const getAllRoles = async () => {
    try {
      const result = await AuthService.getRoles();

      if (result?.data?.status === 200) {
        setRoles(result?.data?.data);
      }

    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
    }
    finally {
      setLoading(false)
    }
  };

  //get all permissions
  const getAllPermissions = async () => {

    try {
      const result = await AuthService.getPermissions();
      if (result?.data?.status === 200) {
        setpermissions(result?.data?.data);
      }

    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
    }
    finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    getAllRoles();
    getAllPermissions();
  }, []);

  return (
    <div className='form-wrapper'>
      {loading && <div className="loader-parent"><div className="_loader"></div></div>}

      <div className="title">Create user</div>

      <div className="row">
        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">First Name <span>*</span></label>
          <input type="text" className='input' value={firstName} onChange={(e) => setFirstName(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Last Name <span>*</span></label>
          <input type="text" className='input' value={lastName} onChange={(e) => setLastName(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Username <span>*</span></label>
          <input type="text" className='input' value={userName} onChange={(e) => setUserName(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Email <span>*</span></label>
          <input type="text" className='input' value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Monthly Target (Cases)</label>
          <input type="text" className='input' value={monthlyCases} onChange={(e) => setMonthlyCases(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Country Name</label>
          <input type="text" className='input' value={country} onChange={(e) => setCountry(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Password <span>*</span></label>
          <input type="text" className='input' value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Retype Password <span>*</span></label>
          <input type="text" className='input' value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Mobile Number</label>
          <input type="text" className='input' value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Profile Image</label>
          <input type="file" className='input' onChange={handleProfile} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">User Role</label>
          <select className="input" value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="">Please select role</option>
            {roles?.map((rol) => <option key={rol?.id} value={rol?.id} >{rol?.name}</option>)}
          </select>
        </div>

        { // Set user client_login_uri only if its role(2) is client
          (role === '2') &&
          <div className="col-12 col-md-6 mb-4">
            <label htmlFor="">Client Login Uri</label>
            <input type="text" className='input' value={clientLoginUri} onChange={(e) => setClientLoginUri(e.target.value)} />
          </div>
        }
      </div>

      <div className="title">Permissions</div>

      <div className="permissions-wrapper">
        {permissions?.map((per) => <div className="checkboxx" key={per?.id}>
          <input
            type="checkbox"
            id={parseInt(per.id)}
            onChange={handleCheckboxChange}
            checked={selectedCheckboxes?.includes(parseInt(per.id))}
          />
          <label htmlFor={parseInt(per.id)}>{per.name}</label>
        </div>)}
      </div>

      <div className="d-flex justify-content-center my-3">
        <button className="button" onClick={createUserFunction}>Create user </button>
      </div>
    </div>
  )
}

export default CreateUser